import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CondominioTrocaPage } from './condominio-troca.page';

const routes: Routes = [
  {
    path: '',
    component: CondominioTrocaPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CondominioTrocaPageRoutingModule {}
